import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { TextSnippetSelector } from "@teamprevent/common/components/TextSnippetSelector";
import { updateQuestion } from "@teamprevent/common/questionnaires/actions";

import { ClinicalNotesProps } from "../../../clinicalNotes/components/ClinicalNotes";
import { loadOhCaseDetail } from "../../../crud/ohCase/actions";
import { taskSelector } from "../../../task/selectors";
import { routeIdSelector as customerIdSelector } from "../../../crud/customer/selectors";
import { routeIdSelector as ohCaseIdSelector } from "../../../crud/ohCase/selectors";
import { ohaMedicalClassificationOptions, medicalClassificationSubCategoryOptions } from "../../../clinicalNotes/models";

const HealthSurveillanceClinicalNotesSections: React.FunctionComponent<ClinicalNotesProps> = (props) => {
    const dispatch = useDispatch();

    const customerId = useSelector(customerIdSelector);
    const ohCaseId = useSelector(ohCaseIdSelector);
    const task = useSelector(taskSelector);

    React.useEffect(() => {
        if (customerId && ohCaseId && !task) {
            loadOhCaseDetail({ customerId, ohCaseId });
        }
    }, [customerId, ohCaseId, task]);

    const updateSnippets = (snippetText: string, sectionId: string, id: string, questionText: string) => {
        const questionAnswer = getAnswerToQuestionWithId(props.questions, id);

        const question = {
            question: questionText,
            answer: (questionAnswer ? questionAnswer + " " : "") + snippetText,
            isValid: true
        };

        dispatch(updateQuestion({ questionnaireKey: props.questionnaireKey, sectionId, id, question }));
    };

    return (
        <AccordionQuestionnaireSection
            title="Clinical Notes"
            id="ClinicalNotes"
            index={props.index}
        >
            <TextQuestion
                readonly={props.readonly}
                questionConfig={({
                    id: "ClinicalNotes",
                    questionText: "Clinical Notes"
                })}
                textSnippetSelector={
                    <TextSnippetSelector
                        onSelect={selectedSnippet => updateSnippets(
                            selectedSnippet,
                            "ClinicalNotes",
                            "ClinicalNotes",
                            "Clinical Notes")
                        }
                        padded
                    />
                }
                mandatory
                multiline
            />
            {(!props.readonly || !!getAnswerToQuestionWithId(props.questions, "MedicalClassification")) &&
            <>
                <DropdownQuestion
                    hideDivider={!!medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId(props.questions, "MedicalClassification") as string]}
                    readonly={props.readonly}
                    questionConfig={({ id: "MedicalClassification", questionText: "Medical Classification" })}
                    filterOldOptions
                    options={ohaMedicalClassificationOptions}
                    mandatory
                />
                {medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId(props.questions, "MedicalClassification") as string]
                    && <DropdownQuestion
                        readonly={props.readonly}
                        questionConfig={({ id: "MedicalClassificationSubCategory", questionText: "Sub Category" })}
                        filterOldOptions
                        options={medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId(
                            props.questions,
                            "MedicalClassification") as string] ?? []}
                        mandatory
                    />
                }
            </>
            }

        </AccordionQuestionnaireSection>
    );
};

export { HealthSurveillanceClinicalNotesSections };
